import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ShopListLayer from "../components/ShopListLayer";

const ShopListPage = () => {
  return (
    <>
      <MasterLayout>
        <ShopListLayer />
      </MasterLayout>
    </>
  );
};

export default ShopListPage;
